window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    require('bootstrap-sass');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

// AI: Echo se instancia SIEMPRE, también sin conexión. No volver a meterlo en un
// `if (navigator.onLine)`: se evaluaba solo al cargar, y una tablet que arrancaba
// sin red se quedaba con `window.Echo` undefined toda la sesión.
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '8c1dc4ea6e4d6a115c6f',
    cluster: 'eu',
    encrypted: true,
});

// AI: la conexión se gobierna a mano a propósito: pusher-js 7 nunca mira
// navigator.onLine y sin red reintenta en bucle. Suscribirse desconectado es
// seguro — solo registra el canal, y subscribeAll() lo suscribe al reconectar.
if (!navigator.onLine) {
    window.Echo.disconnect();
}

window.addEventListener('online', () => window.Echo.connector.pusher.connect());
window.addEventListener('offline', () => window.Echo.disconnect());

